import React, { useContext, useState } from "react";
import { QuestionarioContext } from "../../../../contexts/QuestionarioContext";
import { faEdit, faPen, faPlusCircle, faPoll, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import ModalDommus from "../../../../components/Modal";
import { Alert, ButtonGroup, ButtonToolbar, Dropdown, Row } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { trackPromise } from "react-promise-tracker";
import Swal from "sweetalert2";
import ReactTooltip from "react-tooltip";
import { successToast } from '../../../../components/DommusToast';
import QuestionarioService from '../../../../services/QuestionarioService';
import DommusToggle from "../../../../components/DommusToggle";
import DommusBarraTitulo from "../../../../components/DommusBarraTitulo";
import ItemBarraTitulo from "../../../../components/DommusBarraTitulo/ItemBarraTitulo";
import { QuestionarioForm } from "../QuestionarioForm";
import { AddPerguntaForm } from "./AddPerguntaForm";
import { PerguntaCard } from "./PerguntaCard";
import "./index.css";
import fileDownload from "js-file-download";

export function QuestionarioItem({ questionario }) {
    const [openModal, setOpenModal] = useState(false);
    const [openModalAddPergunta, setOpenModalAddPergunta] = useState(false);
    const { removerQuestionario, atualizarQuestionario } = useContext(QuestionarioContext);

    const handleRemoveQuestionario = () => {
        Swal.fire({
            title: `Deseja realmente excluir esse questionário: ${questionario.descricao}?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sim, excluir!",
            cancelButtonText: "Cancelar!",
        }).then((result) => {
            if (result.isConfirmed) {
                trackPromise(QuestionarioService.delete(questionario.id_questionario))
                    .then(() => {
                        removerQuestionario(questionario.id_questionario);
                        successToast.fire("Questionário removido com sucesso!!");
                    })
                    .catch((erro) => {
                        Swal.fire({
                            titleText: "Ooops...",
                            text: `Houve um erro ao remover o questionário. Status: ${erro.status}, ${erro.response?.data?.message}. ${erro}`,
                            icon: "error",
                        })
                    });
            }
        });
    };

    const handleAlterarStatus = (status) => {
        let dados = {
            oculto: status,
        };
        trackPromise(
            QuestionarioService.update(questionario.id_questionario, dados)
        )
            .then((response) => {
                atualizarQuestionario(response.data);
                successToast.fire("Status alterado com sucesso!!");
            })
            .catch((erro) => {
                Swal.fire({
                    titleText: "Ooops...",
                    text: `Houve um erro ao alterar o questionário. Status: ${erro.status}, ${erro.response?.data?.message}. ${erro}`,
                    icon: "error",
                })
            });
    };

    const handleExportarResultados = (idQuestionario)=>{
      trackPromise(QuestionarioService.exportarResultados(idQuestionario)).then((response)=>{
         fileDownload(
          response?.data,
          "relatorio-" + new Date().toISOString() + ".csv"
        );
      }).catch((erro)=>{
        Swal.fire({
            titleText: "Ooops...",
            text: `Houve um erro ao exportar os resultados do questionário. Status: ${erro.status}, ${erro.response?.data?.message}. ${erro}`,
            icon: "error",
        })
      })     
    }

    const iconesToggle = (
        <Row>
            <>
                <ReactTooltip />
                {!!Number(questionario?.permite_envio_corpo_template) ? 
                    <div className="badger-permissao-template"> Permitido envio no corpo do template </div>
                  : <></>              
                }
                <ButtonToolbar
                    aria-label="Toolbar with button groups"
                    className="justify-content-center"
                >
                    <ButtonGroup
                        className="btn-group-toggle"
                        aria-label="First group"
                    >
                        <button
                            style={{ cursor: "auto" }}
                            className={`btn ${!questionario.oculto ? 'btn-success' : 'btn btn-secondary' }`}
                            onClick={() => {
                                if(questionario.oculto){
                                    handleAlterarStatus(false)
                                }
                            }}
                        >
                            Ativo
                        </button>
                        <button
                            onClick={() => {
                                if(!questionario.oculto){
                                    handleAlterarStatus(true);
                                }
                            }}
                            className={`btn ${questionario.oculto ? 'btn-danger' : 'btn btn-secondary' }`}
                        >
                            Inativo
                        </button>
                    </ButtonGroup>
                </ButtonToolbar>
                <Dropdown className="ml-3 mr-5">
                    <Dropdown.Toggle variant="primary">
                        <FontAwesomeIcon icon={faPen} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            as="button"
                            onClick={() => {
                                setOpenModal(true);
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faEdit}
                                color="#B5DEFF"
                                style={{ marginRight: 10 }}
                            />
                            Editar
                        </Dropdown.Item>
                        <Dropdown.Item
                            as="button"
                            onClick={() => {
                                handleRemoveQuestionario();
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faTrashAlt}
                                color="#E05D5D"
                                style={{ marginRight: 10 }}
                            />
                            Excluir
                        </Dropdown.Item>
                        <Dropdown.Item
                            as="button"
                            onClick={() => {
                              handleExportarResultados(questionario.id_questionario)
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faPoll}
                                color="#378349"
                                style={{ marginRight: 10 }}
                            />
                            Resultados
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </>
        </Row>
    );

    const handleReordenarPerguntas = (result) => {
        if (result?.source && result?.destination && (result?.source.index !== result?.destination.index)) {
            const perguntasOrdenadas = questionario.perguntas?.length ? Array.from(questionario.perguntas) : [];
            const [deletado] = perguntasOrdenadas.splice(result?.source.index, 1);
            perguntasOrdenadas.splice(result?.destination.index, 0, deletado);
            const payload = perguntasOrdenadas.map((pergunta, index) => {
                return {
                    id_pergunta: pergunta.id_pergunta,
                    ordem: index
                }
            })

            QuestionarioService.reordenarPerguntasQuestionario(questionario.id_questionario, payload)
                .then((response) => {
                    let questionarioTemp = questionario;
                    questionarioTemp.perguntas = response.data;
                    atualizarQuestionario(questionarioTemp);
                    successToast.fire('Perguntas ordenadas com sucesso!!')
                })
                .catch(erro => {
                    Swal.fire({
                        titleText: "Ooops...",
                        text: `Houve um erro ao tentar reordenar as perguntas. Status: ${erro?.response?.status}, ${erro?.response?.data?.message}. ${erro}`,
                        icon: "error",
                    })
                })
        }
    };

    return (
        <>
            <DommusToggle title={questionario.descricao} icones={iconesToggle}>
                <DommusBarraTitulo>
                    <ItemBarraTitulo classe="itemBarraTituloEtapa">
                        Perguntas
                    </ItemBarraTitulo>
                    <ItemBarraTitulo
                        classe="btn"
                        onClick={() => {
                            setOpenModalAddPergunta(true);
                        }}
                        data-tip="Adicionar novas perguntas"
                    >
                        <FontAwesomeIcon icon={faPlusCircle} color="#4caf50" />
                    </ItemBarraTitulo>
                </DommusBarraTitulo>
                <DragDropContext onDragEnd={handleReordenarPerguntas}>
                    <Droppable
                        droppableId={`questionario-${questionario.id_questionario}`}
                    >
                        {(provided) => (
                            <div ref={provided.innerRef} {...provided.droppableProps}>
                                {questionario?.perguntas?.length ? (
                                    questionario?.perguntas.map((pergunta, index) => {
                                        return (
                                            <Draggable
                                                key={`questionario-${index}-pergunta-${pergunta.id_pergunta}`}
                                                draggableId={pergunta.id_pergunta.toString()}
                                                index={index}
                                            >
                                                {(provided) => (
                                                    <div
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        ref={provided.innerRef}
                                                        key={index}
                                                    >
                                                        <PerguntaCard key={index} pergunta={pergunta} />
                                                    </div>
                                                )}
                                            </Draggable>
                                        );
                                    })
                                ) : (
                                    <Alert variant="warning">
                                        Não possui nenhuma pergunta vinculada
                                    </Alert>
                                )}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </DommusToggle>
            <ModalDommus
                size="lg"
                open={openModal}
                close={() => setOpenModal(false)}
                titulo="Atualizar Questionário"
                content={
                    <QuestionarioForm
                        questionario={questionario}
                        closeModal={() => {
                            setOpenModal(false);
                        }}
                    />
                }
            />
            <ModalDommus
                size="md"
                open={openModalAddPergunta}
                close={() => setOpenModalAddPergunta(false)}
                titulo="Adicionar Perguntas"
                content={
                    <AddPerguntaForm
                        questionario={questionario}
                        closeModal={() => {
                            setOpenModalAddPergunta(false);
                        }}
                    />
                }
            />
        </>
    );
}

